import { render, staticRenderFns } from "./FeesOnDelivery.vue?vue&type=template&id=ca4e43dc&scoped=true"
import script from "./FeesOnDelivery.vue?vue&type=script&lang=js"
export * from "./FeesOnDelivery.vue?vue&type=script&lang=js"
import style0 from "./FeesOnDelivery.vue?vue&type=style&index=0&id=ca4e43dc&prod&lang=scss"
import style1 from "./FeesOnDelivery.vue?vue&type=style&index=1&id=ca4e43dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4e43dc",
  null
  
)

export default component.exports